import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../campaigns/assets/images/syndycampaign.png'
import _imports_1 from '@/assets/images/brand/brand-default.svg'
import _imports_2 from '../../../assets/images/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-10e97914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-column all-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between" }, null, -1))
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  class: "logo2"
}
const _hoisted_6 = { class: "p-mt-2 p-mb-2 p-d-flex p-flex-column p-justify-between items-block" }
const _hoisted_7 = { class: "name-comp" }
const _hoisted_8 = { class: "p-d-flex p-ai-center p-mt-2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  class: "img-brand"
}
const _hoisted_11 = { class: "name-brand" }
const _hoisted_12 = { class: "p-mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "calendar"
}, null, -1))
const _hoisted_14 = {
  style: {"font-size":"10px"},
  class: "duration-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_ask_hint = _resolveComponent("ask-hint")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "p-d-flex main-block",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToCampaign && $setup.goToCampaign(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        ($props.item?.photo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $props.item?.photo,
              class: "logo2"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5)),
        ($props.item)
          ? (_openBlock(), _createBlock(_component_status_chip, {
              key: 2,
              class: "status-absolute",
              status: $props.item?.status
            }, null, 8, ["status"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString($setup.charset($props.item?.name)) + " ", 1),
          _createElementVNode("div", null, [
            _createTextVNode(" Region: " + _toDisplayString($props.item?.desiredRegions[0]?.value) + " ", 1),
            _withDirectives(_createVNode(_component_ask_hint, { class: "p-ml-1 p-mr-1" }, null, 512), [
              [
                _directive_tooltip,
                $props.item?.desiredRegions[0]?.name,
                void 0,
                { right: true }
              ]
            ]),
            _createTextVNode(" " + _toDisplayString($props.item?.paymentMethod), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          ($props.item?.brand?.photo?.length > 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $props.item?.brand?.photo,
                class: "img-brand"
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createElementBlock("img", _hoisted_10)),
          _createElementVNode("span", _hoisted_11, _toDisplayString($props.item?.brand?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.formatDate($props.item?.dates?.startDate)) + " - " + _toDisplayString($setup.formatDate($props.item?.dates?.endDate) || 'Until Budget is Complete'), 1)
        ])
      ])
    ])
  ]))
}